import { useDebouncedCallback } from "@react-hookz/web";
import { useSetAtom } from "jotai";

import { useStickyElementObserver } from "~/lib/hooks";

import type { AppBarSticky } from "./atoms";
import { appBarStickyAtom } from "./atoms";

export const useAppBarSetStickyHeight = () => {
  const setAppBarSticky = useSetAtom(appBarStickyAtom);
  const updateAppBarSticky = useDebouncedCallback(
    (appBarSticky: AppBarSticky) => setAppBarSticky(appBarSticky),
    [setAppBarSticky],
    100,
  );

  const { reference } = useStickyElementObserver(
    (rect, isSticky) => {
      // For supporting the content is hidden on the top (translateY)
      const height = isSticky ? rect.height + rect.top : 0;
      updateAppBarSticky({
        appBarHeight: rect.height,
        stickyHeight: height,
      });
    },
    { supportScrollEvent: true },
  );

  return {
    reference,
  };
};
